
import Modal from '@/components/common-modal/modal';
import { AutocompleteError, ButtonStyle, Button, Plus, ClientDashboard, Checkbox, PageStyle, Form, Formik, Editor, PRIVACY_POLICY, useEffect,
         useSWR, ErrorPages, PrivacyPolicyAction, useRouter, useState, FormikControl, InputError, useRef, ConfirmationModal,
         closeModalUsingState, Field, PAGE_ANIMATION_OPTIONS, motion, QuickAdd, SkipModal, SidebarAction, PageStyle1, set_privacy_initial_form_data, clearSWRCache, Exclamation} from '@/imports-files/pages/clients/data-privacy/privacy-policy';

function PrivacyPolicy(props)
{
  clearSWRCache('privacy-policy')
  const router                                   =    useRouter();
  const [apiError, setApiError]                  =    useState(null);
  const step                                     =   router.query.step
  const isQuickSetup                             =   router.query.step && router.query.step == 'privacy_policy' ? true : false
  const [skipModal, setSkipModal]                =   useState(false);
  const privacyPolicyAction                      =    new PrivacyPolicyAction(setApiError);
  const errorPages                               =    new ErrorPages()
  const [isLoading, setLoading]                  =    useState(true);
  const { data, error }                          =    useSWR('privacy-policy', () => { return(privacyPolicyAction.getPrivacyPolicy(router))}, { revalidateOnFocus: false });
  const [intitalData, setIntitalData]            =    useState();
  const editorRef                                =    useRef(null);
  const [mandatoryOption, setMandatoryOption]    =    useState(false);
  const formRef                                  =    useRef(null);
  const [policyDataForm, setPolicyDataForm]      =    useState(true);
  const [privacyPolicyForm, setPrivacyPolicyForm] =   useState(false);
  const policyData                               =    set_privacy_initial_form_data();
  const [privacyPolicyPresent, setPrivacyPolicyPresent] = useState(false);
  const [regenerateModal, setRegenerateModal]    =    useState(false);
  const [regeneratePolicy, setRegeneratepolicy]  =    useState(false);
  const [readAccess, setReadAccees]              =    useState(props.session.role == 'SubAdministrator' ? true : false);
  const [isSafari, setIsSafari] = useState(false);
  useEffect(async() => {
                      if(data)
                      {
                          setPrivacyPolicyPresent(data.privacy_record_present)
                          if(data.privacy_record_present && !regeneratePolicy){
                            setPrivacyPolicyForm(true);
                          }
                          data.policy.terms_accepted = data.policy.terms_accepted_at ? true : false
                          data.policy.description = data.policy.description || ''
                          await setIntitalData(data.policy)
                          setLoading(false);

                          if(isQuickSetup)
                              setTimeout(() => {
                              new SidebarAction().subsidebarQuickSetupChangeIcon(data.sidebar_options?.complete_steps, 'privacy_policy');
                          }, 750);
                      }
                  },[data])

  useEffect(() => {
    if (typeof window !== "undefined") {
      const userAgent = navigator.userAgent;
      setIsSafari(userAgent.includes("Safari") && !userAgent.includes("Chrome"));
    }
  }, []);
   
  if(isLoading || error || errorPages.handleErrorCodes(apiError?.status))
  {
    var renderPage  =  (error || apiError) ? errorPages.renderPage(error?.status || apiError?.status, router) : null;
    return renderPage;
  }

  return (
    <motion.div key={router.route} initial="pageInitial" animate="pageAnimate" variants={PAGE_ANIMATION_OPTIONS}>
    <div className={`Privcy DashboardPageContent DashboardPageContentRight ${PageStyle.PrivacyPolicy} ${PageStyle.NewJob}`}>
      <div className={PageStyle.NewJob__Container}>

        <div className={PageStyle.EmailTemplates__TopSection}>
          <div className={PageStyle.ClientCompany__BackSection}></div>
          <div className={PageStyle.JobList__QuickAdd}>
            <QuickAdd session={props.session}/>
          </div>
        </div>

        <div className={PageStyle.ClientCompany__FormSection}>
          <h1 className={`mt0 ${PageStyle.ClientCompany__Heading}`}>
            {PRIVACY_POLICY.texts.heading}: <span className={PageStyle.ClientCompany__Company}>Privacy Policy</span>
          </h1>

        </div>
        <h4 className={`mb0 ${PageStyle.ClientCompany__Subheading}`}>{PRIVACY_POLICY.texts.selector_label}</h4>


 { policyDataForm && !privacyPolicyPresent && <Formik initialValues       =  {policyData}
                  innerRef            =   {formRef}
                  validationSchema    =   {PRIVACY_POLICY.privacyPolicyFormDataValidation}
                  onSubmit            =   { (values , formik)  => {
                                                    privacyPolicyAction.generatePolicyData(values, setIntitalData, router, isQuickSetup, setPolicyDataForm, setPrivacyPolicyForm, formik)
                                                    } }   >
            {(formik) => (

                        <Form className={`${PageStyle.Form}`}>
                          <div className={PageStyle.Form__Table}>
                             <div className={PageStyle.Form__TableRow}>
                              <div className={PageStyle.Form__TableCol}>
                              <span className={PageStyle.Form__Label}>
                               Company Name *
                              </span>

                               <FormikControl
                                control="input"
                                type="text"
                                name="company_name"
                                className={PageStyle.Form__Input}
                                formik={formik}
                                errorClass={PageStyle.Form__Error}
                                style={InputError(formik, "company_name")}
                              />
                            </div>
                              <div className={PageStyle.Form__TableCol}></div>
                          </div>

                          <div className={PageStyle.Form__TableRow}>
                              <div className={PageStyle.Form__TableCol}>
                              <span className={PageStyle.Form__Label}>
                                Account Owner *
                              </span>

                               <FormikControl
                                control="input"
                                type="text"
                                name="account_owner"
                                className={PageStyle.Form__Input}
                                formik={formik}
                                errorClass={PageStyle.Form__Error}
                                style={InputError(formik, "account_owner")}
                              />
                            </div>

                            <div className={PageStyle.Form__TableCol}>
                              <span className={PageStyle.Form__Label}>
                                Contact Number *
                              </span>

                              <FormikControl
                                control="input"
                                type="text"
                                name="contact_number"
                                className={PageStyle.Form__Input}
                                formik={formik}
                                errorClass={PageStyle.Form__Error}
                                style={InputError(formik, "contact_number")}
                              />
                            </div>
                          </div>
                            <div className={PageStyle.Form__TableRow}>
                              <div className={PageStyle.Form__TableCol}>
                              <span className={PageStyle.Form__Label}>
                                Email *
                              </span>

                               <FormikControl
                                control="input"
                                type="text"
                                name="email"
                                className={PageStyle.Form__Input}
                                formik={formik}
                                errorClass={PageStyle.Form__Error}
                                style={InputError(formik, "email")}
                              />
                            </div>

                            <div className={PageStyle.Form__TableCol}>
                              <span className={PageStyle.Form__Label}>
                                Address *
                              </span>

                              <FormikControl
                                control="input"
                                type="text"
                                name="address"
                                className={PageStyle.Form__Input}
                                formik={formik}
                                errorClass={PageStyle.Form__Error}
                                style={InputError(formik, "address")}
                              />
                            </div>
                            {skipModal && <SkipModal setBtnPopup={setSkipModal} router={router}></SkipModal>}
                              <div className={`space`}></div>

                            {!isQuickSetup && <div className={PageStyle.NewJob__SubmitSection}>
                                <div className='space'></div>
                                <Button buttonstyle={ButtonStyle.primarybtn} type="button" onClick={ async() => {
                                  await formik.validateForm()
                                  formRef.current.submitForm()
                                  }}>
                                  Generate Policy
                                </Button>
                              </div> }

                              {isQuickSetup && <div className={PageStyle.NewJob__SubmitSection}>

                                  <Button buttonstyle  =  {PageStyle.secondarybtnborder}
                                          type         =  "button"
                                          onClick      =  {() => { setSkipModal(true) }}
                                  >
                                    {PRIVACY_POLICY.texts.skip}
                                  </Button>

                                  <Button buttonstyle  = {PageStyle.primarybtn}
                                          type         = "button"
                                          onClick={ async() => { await formik.validateForm()
                                                                formRef.current.submitForm()
                                          }}
                                  >
                                        {PRIVACY_POLICY.texts.next}
                                  </Button>
                              </div>}
                          </div>

                        </div>
                        </Form>
                     )}
             </Formik>

}

{privacyPolicyForm && <Formik   initialValues       =   {intitalData}
                  validationSchema    =   {PRIVACY_POLICY.validationSchema}
                  innerRef            =   {formRef}
                  onSubmit            =   { (values)  => {
                                                         privacyPolicyAction.submitData(values, setIntitalData, router, isQuickSetup)
                                                    } }   >
            {(formik) => (

                        <Form>



{/*                           <div className={`WrapperRadio mt15`}> */}
{/*  */}
{/*                           <label className={`Dpflex WrapperRadioContainer`}> */}
{/*                           <Field type="radio" name="candidly_template" id="option-1" value={false} onChange={(event) =>{ */}
{/*                                                         privacyPolicyAction.onPrivacyPolicyChange(event, formik) */}
{/*                                                       }} /> */}
{/*                             <span className="WrapperRadiocheckmark"></span> <span className={`ml5`}>Add your own</span> */}
{/*                           </label> */}
{/*  */}
{/*                           <label className={`Dpflex WrapperRadioContainer`}> */}
{/*                           <Field type="radio" name="candidly_template" id="option-2" value={true} onChange={(event) =>{ */}
{/*                                                         privacyPolicyAction.onPrivacyPolicyChange(event, formik) */}
{/*                                                       }}/> */}
{/*                             <span className="WrapperRadiocheckmark"></span> <span className={`ml5`}>Use template by Charlie Recruit</span> */}
{/*                           </label> */}
{/*  */}
{/*                           </div> */}
                
                          <div className={`mt30 ${PageStyle.PrivacyPolicy}`}>
                          {!isSafari && (
                            <div className="NotSupport">
                              <Exclamation /> {`Your browser doesn't support direct clipboard access. Please use the keyboard shortcuts: Ctrl+X/C/V (Windows) or ⌘+X/C/V (Mac).`}
                            </div>
                          )}
                              <div className={PageStyle.Form__TableRow}>
                                <FormikControl   apiKey          =   {process.env.NEXT_PUBLIC_TINYMCE_API_KEY}
                                                 control         =   "customEditor"
                                                 formik          =   {formik}
                                                 onInit          =   {(evt, editor) => editorRef.current = editor}
                                                 textareaName    =   {'description'}
                                                 identifierClass =   {'description'}
                                                 style           =   {InputError(formik, 'description')}
                                                 value           =   {formik.values.description}
                                                 disabled        =   {readAccess}
                                                 onEditorChange  =   {(value) => {
                                                                                     formik.setFieldValue(`description`, value);
                                                                                 }}
                                                 init            =   {{
                                                                                   height: 400,
                                                                                   resize: false,
                                                                                   menubar: false,
                                                                                   plugins: [
                                                                                      'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
                                                                                      'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                                                                                      'insertdatetime', 'media', 'table', 'help', 'wordcount', 'contextmenu', 'paste'
                                                                                    ],
                                                                                  toolbar: 'undo redo | blocks | ' +
                                                                                  'bold italic backcolor | link | alignleft aligncenter ' +
                                                                                  'alignright alignjustify | bullist numlist outdent indent | ' +
                                                                                  'removeformat | help',
                                                                                  contextmenu: isSafari ? "copy paste | link" : "link",
                                                                                  paste_as_text: true, 
                                                                                  content_style: 'body { font-family:Gellix,Arial,sans-serif; font-size:14px; color: #00325A; }',

                                                                     }}
                                />
                              </div>

                              <div>
                                <span className={PageStyle.ClientCompany__LastEdited}>{PRIVACY_POLICY.texts.label_1}: {intitalData.edited_by_name && intitalData.updated_at ?  `${intitalData.edited_by_name},  ${intitalData.updated_at}` : '-'} </span>
                              </div>

                              <div className={`${PageStyle.Form__TableCol} ${PageStyle.TermsCondition}`}>
                                <div className={`${PageStyle.TermsCondition__alignterms} ${readAccess ? `cursor-nodrop` : ''}`}>
                                  <Checkbox
                                    name        =   "terms_accepted"
                                    inputProps  =   {{ "aria-label": "Terms and Conditions" }}
                                    checked     =   {formik.values.terms_accepted}
                                    onChange    =   {(event)=> {formik.setFieldValue('terms_accepted', event.target.checked)}}
                                    disabled    =   {readAccess}
                                  />{" "}
                                  <div className={PageStyle.Form__CheckLabel}>
                                    <p>{PRIVACY_POLICY.texts.terms.para1}</p>
                                    <br/>
                                    <p>{PRIVACY_POLICY.texts.terms.para2}</p>
                                    <br/>
                                    <p>{PRIVACY_POLICY.texts.terms.para3}</p>
                                  </div>
                                </div>
                               <div> <AutocompleteError
                                  name="terms_accepted"
                                  errorClass={PageStyle.Form__Error}
                                  formik = {formik}
                                  style={InputError(formik, "terms_accepted")}
                                  />
                                </div>
                              </div>

                              {/* {!formik.values.candidly_template && <h4 className={`${PageStyle.ClientCompany__Subheading} mb20`}>{PRIVACY_POLICY.texts.create_your_own}</h4>} */}

                              {/* {!formik.values.candidly_template && <div className={PageStyle.PrivacyPolicy__Paragraphs}> */}
                              {/*   <p>{PRIVACY_POLICY.texts.privacy_policy.para1}</p> */}
                              {/*   <p>{PRIVACY_POLICY.texts.privacy_policy.para2}</p> */}
                              {/*   <p>{PRIVACY_POLICY.texts.privacy_policy.para3}</p> */}
                              {/* </div>} */}



                              {skipModal && <SkipModal setBtnPopup={setSkipModal} router={router}></SkipModal>}
                              <div className={`space`}></div>

                              {!isQuickSetup && <div className={PageStyle.NewJob__SubmitSection}>
                                 <Button buttonstyle={ButtonStyle.secondarybtnborder} type="button" disabled={readAccess} onClick={ async() => {
                                      setRegenerateModal(true);
                                  }}>
                                  Regenerate Policy
                                </Button>

                                <Button buttonstyle={`${readAccess ? ButtonStyle.graybtnborder : ButtonStyle.primarybtn}`} type="button" disabled={readAccess} onClick={ async() => {
                                  await formik.validateForm()
                                  formRef.current.submitForm()
                                  // formRef.current.isValid ? setMandatoryOption(true) : formRef.current.submitForm()
                                  }}>
                                  {PRIVACY_POLICY.texts.button_2}
                                </Button>
                              </div>}

                              {isQuickSetup && <div className={PageStyle.NewJob__SubmitSectionThreeBtn}>

                               <Button buttonstyle  =  {PageStyle.secondarybtnborder}
                                          type         =  "button"
                                          onClick      =  {() => { setSkipModal(true) }}
                                          disabled     =  {readAccess}
                                  >
                                    {PRIVACY_POLICY.texts.skip}
                                </Button>

                                <Button buttonstyle={ButtonStyle.secondarybtnborder} type="button" disabled={readAccess} onClick={ async() => {
                                      setRegenerateModal(true);
                                  }}>
                                  Regenerate Policy
                                </Button>

                                <Button buttonstyle  = {PageStyle.primarybtn}
                                          type         = "button"
                                          onClick      = {async() => {
                                              await formik.validateForm()
                                              formRef.current.submitForm()
                                              // formRef.current.isValid ? setMandatoryOption(true) : formRef.current.submitForm()
                                            }
                                          }
                                          disabled     = {readAccess}
                                  >
                                        {PRIVACY_POLICY.texts.next}
                                  </Button>
                              </div>}

                          </div>


                          </Form>
                     )}
        </Formik>
}
      </div>

      {/* -------------------- CANDIDATE DELETE MODAL -------------------- */}

      {mandatoryOption && (
          <Modal
            type="confirmation"
            message={
              formRef.current.values.candidly_template
                ? PRIVACY_POLICY.texts.template_confirmation
                : PRIVACY_POLICY.texts.own_confirmation
            } // TODO:-  Need to changes
            closeModal={() => {
              closeModalUsingState(false, setMandatoryOption);
            }}
            btnAction={() => {
              setMandatoryOption(false);
              formRef.current.submitForm();
            }}
            texts={{
              button1_text: "Cancel",
              button2_text: "Confirm",
            }}
          />
        )}

      {regenerateModal && (
          <Modal
            type="confirmation"
            ButtonWidth = {true}
            message={ "You have chosen to regenerate your Privacy Policy. All your changes will be lost. Are you sure to proceed." }
            closeModal={() => {
                setRegenerateModal(false);
            }}
            btnAction={() => {
                setPrivacyPolicyPresent(false)
                setRegeneratepolicy(true);
                setPrivacyPolicyForm(false);
                setPolicyDataForm(true);
                setRegenerateModal(false);
            }}
            texts={{
              button1_text: "Cancel",
              button2_text: "Create Privacy Policy",
            }}
          />
        )}

      {/* -------------------- CANDIDATE DELETE MODAL -------------------- */}

    </div>
    </motion.div>
  )
}
PrivacyPolicy.layout = ClientDashboard;
export default PrivacyPolicy;